import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { addProps } from 'utils/recompose';
import {
  setSelectedSeriesId,
  fetchSeriesPipeline,
} from 'reducers/seriesPipeline/actions';
import { selectedSeriesId } from 'reducers/seriesPipeline/selectors';
import { mini } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import bmwInactiveAnalytics from '../images/ic-analytics-inactive.svg';
import miniInactiveAnalytics from '../images/mini-icon-analytics-inactive.svg';
import bmwActiveAnalytics from '../images/ic-analytics-active.svg';
import miniActiveAnalytics from '../images/mini-icon-analytics-active.svg';

const mapStateToProps = combineSelectors({
  selectedSeriesId,
  mini,
});

export const alt = ({ selectedSeriesId, seriesId }) =>
  selectedSeriesId === seriesId
    ? 'toggle-details-active'
    : 'toggle-details-inactive';

export const src = ({
  selectedSeriesId,
  seriesId,
  activeAnalytics,
  inactiveAnalytics,
}) => (selectedSeriesId === seriesId ? activeAnalytics : inactiveAnalytics);

export const activeAnalytics = ({ mini }) =>
  mini ? miniActiveAnalytics : bmwActiveAnalytics;

export const inactiveAnalytics = ({ mini }) =>
  mini ? miniInactiveAnalytics : bmwInactiveAnalytics;

export const onClick = ({
  setSelectedSeriesId,
  selectedSeriesId,
  seriesId,
  fetchSeriesPipeline,
  mini,
}) => event => {
  let id = selectedSeriesId === seriesId ? null : seriesId;
  if (selectedSeriesId !== seriesId) {
    fetchSeriesPipeline({ id, mini });
  }
  setSelectedSeriesId(id);
};

export default compose(
  connect(
    mapStateToProps,
    { setSelectedSeriesId, fetchSeriesPipeline },
  ),
  withHandlers({ onClick }),
  addProps({ activeAnalytics, inactiveAnalytics }),
  addProps({ alt, src }),
);
